import React from "react";
import { useTable } from "../../Components/useTable";

const BannerImagesList = () => {
  const type = "Images";
  const limitPerpage = 100;
  const pageRowslinit = [100, 200, 500, 1000];
  const headCells = [
    { id: "id", numeric: false, label: "Image Id" },
    { id: "url", numeric: false, label: "Image" },
    { id: "type", numeric: false, label: "Type" },
    { id: "screen", numeric: false, label: "Screen" },
    { id: "link", numeric: false, label: "Link" },
    { id: "isInternalLink", numeric: false, label: "Internal Link" },
    { id: "created", numeric: false, label: "Created at" },
    { id: "action", numeric: false, label: "Action" },
  ];

  const { tableUI } = useTable({
    headCells,
    type,
    limitPerpage,
    pageRowslinit,
  });
  return (
    <div className="admin-body">
      <div className="table-area">{tableUI}</div>
    </div>
  );
};

export default BannerImagesList;
